export enum AuthKeys {
    AcceessToken = 'accesstoken',
    User = 'user',
    RefreshToken = 'refreshToken',
    AppData = 'appData',
    EsignResume = 'esignResume'
}

export enum LocalStorageKeys {
    ContentLang = 'content-lang'
}
